module.exports = __webpack_public_path__ + "static/media/18ECA29.cf4529cf.jpg";